import { render, staticRenderFns } from "./materialList.vue?vue&type=template&id=3e2fe673&"
import script from "./materialList.vue?vue&type=script&lang=js&"
export * from "./materialList.vue?vue&type=script&lang=js&"
import style0 from "./materialList.vue?vue&type=style&index=0&id=3e2fe673&prod&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports